module.exports = __webpack_public_path__ + "assets/entrance-normal-070eb50a.png";